import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plus-thin",
  "use": "icon-plus-thin-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill-rule=\"evenodd\" viewBox=\"0 0 24 24\" id=\"icon-plus-thin\"><path d=\"M11 11v-11h1v11h11v1h-11v11h-1v-11h-11v-1h11z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol